module.exports = __webpack_public_path__ + "static/img/img1.c3a5ac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/konyhai-kiegeszitok/img1.jpg
// module id = 556
// module chunks = 0